import useAccessRequestTemplatesApi from './use-access-request-templates-api';
import { API_LIMIT } from '@client-app-sdk/utils/constants';
import useListQuery from '@client-app-sdk/utils/use-list-query';
import { AccessRequestTemplatesApiListAccessRequestTemplatesRequest } from '@client-app-sdk';
import { QueryFunctionContext } from '@tanstack/react-query';

const QUERY_KEY = 'listRequestTemplates';

export default function useListAccessRequestTemplates({
  limit,
  skip,
  ...props
}: AccessRequestTemplatesApiListAccessRequestTemplatesRequest) {
  const api = useAccessRequestTemplatesApi();

  const fetchRequestTemplates = async ({ pageParam: skipParam = 0 }: QueryFunctionContext) =>
    api.listAccessRequestTemplates({
      ...props,
      limit: limit ?? API_LIMIT,
      skip: skipParam,
    });

  return useListQuery({ fetchMethod: fetchRequestTemplates, queryKey: [QUERY_KEY, props] });
}
